<template>
  <v-layout>
    <v-flex>
      <v-menu
        v-model="menu1"
        :nudge-left="40"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="startDate"
            :label="english ? 'Manifest Start Date' : 'Manifeste de'"
            prepend-inner-icon="event"
            :rules="[
              !startDateCheck
                ? true
                : 'Start Date cannot be greater than End Date.',
            ]"
            readonly
            box
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="startDate"
          show-current
          color="#138397"
          @input="updateStartDate()"
        ></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex>
      <v-menu
        v-model="menu2"
        :nudge-left="10"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="endDate"
            :label="english ? 'Manifest End Date' : 'Manifeste a'"
            append-icon="send"
            :rules="[
              !endDateCheck ? true : 'End Date cannot be less than Start Date.',
            ]"
            @click:append="getData()"
            readonly
            box
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="endDate"
          show-current
          color="#138397"
          @input="updateEndDate()"
        ></v-date-picker>
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      startDate: moment()
        .subtract(2, "months")
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      menu1: false,
      menu2: false,
    };
  },
  computed: {
    ...mapState(["english"]),
    startDateCheck() {
      return (
        moment(this.startDate, "YYYY-MM-DD").toDate().getTime() >
        moment(this.endDate, "YYYY-MM-DD").toDate().getTime()
      );
    },
    endDateCheck() {
      return (
        moment(this.endDate, "YYYY-MM-DD").toDate().getTime() <
        moment(this.startDate, "YYYY-MM-DD").toDate().getTime()
      );
    },
  },
  methods: {
    ...mapMutations(["DATE_TO_MANIFEST", "DATE_FROM_MANIFEST"]),
    updateStartDate: function () {
      this.DATE_FROM_MANIFEST(this.startDate);
      this.menu1 = false;
    },
    updateEndDate: function () {
      this.DATE_TO_MANIFEST(this.endDate);
      this.menu2 = false;
    },
    getData() {
      if (!this.startDateCheck && !this.endDateCheck) {
        this.$store.dispatch("LOAD_ACTUAL_MANIFEST_DATA");
        this.$store.dispatch("LOAD_EXCEPTION_MANIFEST_DATA");
        this.$store.dispatch("LOAD_MISSING_MANIFEST_DATA");
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
